/****************************************************
 * Module Name:  mixSellProforma.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Select from "react-select";
import { Button, Box, CircularProgress, Tooltip, Typography, Stack, FormGroup, FormControlLabel, Switch, } from "@mui/material";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Utility from "../../utility/utility";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "../common/commonSnackBar";
import MixSaleProxy from "../../utility/proxy/manager/mixProxy/mixSalesProxy";
import { BsFilePdf } from "react-icons/bs";
import PDFModal from "../common/pdfModal";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import renderCellExpand from "../common/dataGridCellExpand";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import PageTitle from "../common/pageTitle";
import UserDetailModal from "../operations/userDetailModal";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
  Mylayout: {
    fillColor: function (rowIndex, node, columnIndex) {
      return rowIndex % 2 === 0 ? "#CCCCCC" : null;
    },
  },
};

const lStatusOption = [
  { value: "*", label: "-- ANY --" },
  { value: "NEW", label: "NEW" },
  { value: "INPROGRESS", label: "INPROGRESS" },
  { value: "CLOSED", label: "CLOSED" },
  { value: "DELETED", label: "DELETED" },
];

const MixSellProforma = () => {

  const local_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_PROFORMA);

  const [user, setUser] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [status, setStatus] = useState(lStatusOption[0]);
  const [listData, setListData] = useState([]);
  const [salesListLoader, setSalesListLoader] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [pdfName, setPdfName] = useState("");
  const [pdfByte, setPdfByte] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 1)));
  const [toDate, setToDate] = useState(new Date());
  const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
  const [bucketId, setBucketId] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [groupBy, setGroupBy] = useState(true);
  const [totalUSD, setTotalUSD] = useState(0);
  const [totalINR, setTotalINR] = useState(0);

  const [showUserDetailModal, setShowUserDetailModal] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    PageTitle("MIX_REPORT_PROFORMA");
    getAllCustomerData();
  }, []);

  const getAllCustomerData = () => {
    let locationid = Utility.isReadAllowed(local_Permission) ? Constants.loggedInUser.locationid : -1;
    let userid = Utility.isReadAllowed(local_Permission) ? -1 : Constants.loggedInUser.id;
    MixSaleProxy.GetCustomersCreatedProforma(locationid, userid, Constants.loggedInUser.usertype, (response) => {
      if (response)
        setAllUserData(response);
    });
  }

  const setAllUserData = (response) => {
    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.companyname,
      };
      optionsArray.push(option);
      return true;
    });
    setUserOption(optionsArray);
    setUser(optionsArray.length > 0 ? [optionsArray[0]] : user);
    handleSearch(fromDate, toDate, [optionsArray[0]], optionsArray);
  };

  const fullOptionToValue = (selectedData, userOption) => {
    let newArr = [];
    selectedData.map((data) => {
      if (data.value === "*") {
        return userOption.map((option) => {
          if (option.value !== "*") {
            newArr.push(option.value);
            return true;
          }
          return true;
        });
      }
      return true;
    })
    return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
  };

  const handleSearch = (fromDate, toDate, user, userOption) => {
    if (fromDate && toDate && user) {
      setSalesListLoader(true);
      let data = {
        from: dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z",
        to: dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z",
        users: fullOptionToValue(user, userOption),
        locationid: Utility.isReadAllowed(local_Permission) ? Constants.loggedInUser.locationid : -1,
        status: status.label === "-- ANY --" ? ["NEW", "INPROGRESS", "CLOSED", "DELETED"] : [status.value],
      };

      MixSaleProxy.GetAllMixProformaReport(Constants.loggedInUser.id, Constants.loggedInUser.usertype, data, (response) => {
        if (response) {
          const uniqueFilterValues = {
            customercompanyname: Utility.getDistinctOptions(response, "customercompanyname"),
            status: Utility.getDistinctOptions(response, "status"),
            exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
            user: Utility.getDistinctOptions(response, "userid"),
            broker: Utility.getDistinctOptions(response, "brokerid"),
            customer: Utility.getDistinctOptions(response, "customerid"),
            proformacustomer: Utility.getDistinctOptions(response, "proformacustomerid"),
            tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
          };
          const combinedFilterValues = {
            customercompanyname: uniqueFilterValues.customercompanyname,
            status: uniqueFilterValues.status,
            exchangecurrency: uniqueFilterValues.exchangecurrency,
            user: uniqueFilterValues.user.map(value => {
              const matchingItem = response.find(item => item.userid === value);
              return matchingItem ? `${value} | ${matchingItem.username}` : [];
            }),
            broker: uniqueFilterValues.broker.map(value => {
              const matchingItem = response.find(item => item.brokerid === value);
              if (matchingItem) {
                let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokercompanyname}`;
                return displayValue;
              }
              return [];
            }),
            customer: uniqueFilterValues.customer.map(value => {
              const matchingItem = response.find(item => item.customerid === value);
              return matchingItem ? `${value} | ${matchingItem.customercompanyname}` : [];
            }),
            proformacustomer: uniqueFilterValues.proformacustomer.map(value => {
              const matchingItem = response.find(item => item.proformacustomerid === value);
              if (matchingItem) {
                let displayValue = (!matchingItem.proformacustomerid) ? " - " : `${matchingItem.proformacustomerid} | ${matchingItem.proformacustomercompanyname}`;
                return displayValue;
              }
              return [];
            }),
            tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
              const matchingItem = response.find(item => item.tradingcompanyid === value);
              return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
            }),
            stonetype: Utility.getDistinctOptions(response, "stonetype"),

          };
          setFilterValues(combinedFilterValues);
          setListData(response);
          if (response.length > 0)
            handleArray(response);
          setSalesListLoader(false);
        } else {
          setSalesListLoader(false);
          setErrorSnackbar(true);
        }
      });
    }
  };

  const handleArray = (lListData) => {
    let newMainData = [], totalUSD = 0, totalINR = 0;
    const stonetypefullname = new Set();
    if (lListData.length > 0) {
      lListData.forEach((list) => {
        stonetypefullname.add(...Utility.getDistinctOptions(list.buckets, "stonetypefullname"));
        list.buckets.forEach((stone) => {
          stone.exchangecurrency = list.exchangecurrency
          stone.exchangerate = list.exchangerate
          newMainData.push(stone);

          totalUSD += stone.final_amount;
          totalINR += stone.final_amountinr;
        });
      });
    }

    setFilterValues(val => ({ ...val, stonetypefullname: [...stonetypefullname] }));
    setMainData(newMainData);
    setTotalUSD(totalUSD.toFixed(2));
    setTotalINR(totalINR.toFixed(2));
  };

  const downloadPDF = (proformaid, fileBytes) => {
    setPdfByte(fileBytes);
    setPdfName(`Profroma_` + proformaid + `.pdf`);
    openModal()
  }

  const handleBucketDetailModal = (params) => {
    setBucketId(params.value);
    setShowBucketDetailModal(true)
  };

  const columnName = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "perfomaid",
      headerName: "PROFORMA ID",
      headerAlign: "center",
      width: 110,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "bucketid",
      headerName: "BUCKETID",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline !important",
            color: 'black !important'
          }}
          onClick={() => handleBucketDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "bucketname",
      headerName: "BUCKET NAME",
      headerAlign: "center",
      align: "center",
      width: 300,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.bucketname : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
      renderCell: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
    },
    {
      field: "stonetypefullname",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      width: 90,
      valueOptions: filterValues ? filterValues.stonetypefullname : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      field: "qty",
      headerName: "QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "piece",
      headerName: "PIECES",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
    },
    {
      field: "exchangecurrency",
      headerName: "EX. CURRENCY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 115,
    },
    {
      field: "exchangerate",
      headerName: "EX. RATE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
    },
    {
      field: "sellqty",
      headerName: "SELL QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    },
    {
      field: "price",
      headerName: "PPC $",
      headerAlign: "center",
      type: "number",
      align: "center",
      width: 80,
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    {
      field: "priceinr",
      headerName: "PPC ₹",
      headerAlign: "center",
      type: "number",
      align: "center",
      width: 80,
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.priceinr)
    },
    {
      field: "discount1",
      headerName: "DIS 1",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "discount2",
      headerName: "DIS 2",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 55,
    },
    {
      field: "discount3",
      headerName: "DIS 3",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "final_amount",
      headerName: "FINAL AMOUNT $",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amount)
    },
    {
      field: "final_amountinr",
      headerName: "FINAL AMOUNT ₹",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amountinr)
    },
    {
      field: "remarks",
      headerName: "REMARKS",
      headerAlign: "center",
      align: "center",
      width: 90,
    },
  ];

  const materialDefaultColumns = [
    {
      headerName: "PROFORMA ID",
      field: "id",
      headerAlign: "center",
      width: 130,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "STONETYPE",
      field: "stonetype",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
      width: 115,
    },
    {
      headerName: "USER",
      field: "userid",
      width: 185,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.user : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.userid} | ${params.row.username}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {`${params.row.userid} | ${params.row.username}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "BROKER COMPANY",
      field: "brokerid",
      width: 185,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.broker : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.brokerid} | ${params.row.brokercompanyname}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {(params.row.brokerid === -1 || params.row.brokerid === null) ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "CUSTOMER COMPANY",
      field: "customerid",
      width: 225,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.customerid} | ${params.row.customercompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.customerid} | ${params.row.customercompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "TRADING COMPANY",
      field: "tradingcompanyid",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.tradingcompany : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXCHANGE CURRENCY",
      field: "exchangecurrency",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.exchangecurrency : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      headerName: "EXCHANGE RATE",
      field: "exchangerate",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPING COST",
      field: "shippingcost",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 110,
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL PAYABLE AMOUNT",
      field: "finalpayableamount",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 170,
      renderCell: renderCellExpand
    },
    {
      headerName: "DAYS",
      field: "days",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand
    },
    {
      headerName: "PDF",
      field: "performapdf",
      renderCell: (params) => (
        <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.performapdf)} />
      ),
      export: false,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "DATE",
      field: "date",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXPORT",
      field: "export",
      renderCell: (params) =>
        params.row.export ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      align: "center",
      width: 85,
    },
    {
      headerName: "COUNTRY OF FINAL DESTINATION",
      field: "countryoffinaldestination",
      headerAlign: "center",
      align: "center",
      width: 220,
      renderCell: renderCellExpand
    },
    {
      headerName: "COUNTRY OF ORIGIN",
      field: "countryoforigin",
      headerAlign: "center",
      align: "center",
      width: 145,
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL DESTINATION",
      field: "finaldestination",
      headerAlign: "center",
      align: "center",
      width: 135,
      renderCell: renderCellExpand
    },
    {
      headerName: "ENSURED BY",
      field: "ensuredby",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderCell: renderCellExpand
    },
    {
      headerName: "BANK THROUGH",
      field: "bankthrough",
      renderCell: (params) =>
        params.row.bankthrough ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      width: 115,
      align: "center",
    },
    {
      headerName: "PORT OF LOADING",
      field: "portofloading",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPED BY",
      field: "shippedby",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "PORT OF DISCHARGE",
      field: "portofdischarge",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand
    },
    {
      headerName: "REMARKS",
      field: "remarks",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand
    },
    {
      headerName: "TERMS",
      field: "terms",
      headerAlign: "center",
      type: "number",
      width: 60,
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "DUE DATE",
      field: "duedate",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
      headerAlign: "center",
      align: "center",
    },
  ];

  const columns = columnName;

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, mainData }) {
    let row = mainData.filter(data => data.perfomaid === rowProp.id);
    return (
      <Stack
        sx={{ p: 1, height: '100%', boxSizing: 'border-box', borderBottom: "1px solid lightgrey" }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "85vw",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto',
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={row}
            getRowId={(row) => row.id}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              maxHeight: '35vh'
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns id, the other columns will remain visible
                  id: false,
                },
              }
            }}
            hideFooter
          />
        </Box>
      </Stack>
    );
  }

  return (
    <div>
      <Box px={1}>
        <CommonSnackbar
          show={errorSnackbar}
          message={Constants.APiFailErrorMessage}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          title={"Failed"}
          handleClose={() => setErrorSnackbar(false)}
        />

        {/*need to send pdf in byte string to modal */}
        <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />

        {showBucketDetailModal ? (
          <BucketDetailModal
            show={showBucketDetailModal}
            bucketId={bucketId}
            handleClose={() => setShowBucketDetailModal(false)}
          />
        ) : null}

        {showUserDetailModal ? (
          <UserDetailModal
            show={true}
            handleClose={() => setShowUserDetailModal(false)}
            handleSelect={(selectedOption) => {
              const selectedCustomers = userOption.filter(opt =>
                selectedOption.includes(opt.value)
              );
              setUser(selectedCustomers);
              setShowUserDetailModal(false)
            }}
            userids={userOption.filter(option => option.value !== "*").map(cust => cust.value)}
            selectedIds={user.length !== 0 ? user.map(iCustomer => iCustomer.value) : []}
            usertype={"C"}
            loading={showUserDetailModal}
            isMulti={true}
          />
        ) : null}

        <Box sx={{ display: "flex", flexWrap: "wrap", width: "100%", my: 1, alignItems: "center", gap: "16px" }}>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "25%",
              gap: "10px",
            }}
          >
            <Box>
              <Typography>Customer Company {Constants.loggedInUser.usertype !== "C" ? "" : " :- "}</Typography>
            </Box>
            {Constants.loggedInUser.usertype !== "C" ? (
              <>
                <Box sx={{ width: "100%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    isMulti
                    closeMenuOnSelect={false}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={user}
                    isSearchable={true}
                    name="Customer"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={userOption}
                    onChange={(e) => setUser(e)}
                  />
                </Box>
                <Tooltip title="View More Data">
                  <span style={{ cursor: "pointer", marginLeft: "0px" }}>
                    <OpenInNewIcon
                      fontSize="medium"
                      color="action"
                      onClick={() => setShowUserDetailModal(true)}
                    />
                  </span>
                </Tooltip>
              </>
            ) : (
              <Box>
                <Typography fontWeight={Constants.defaultFontWeightBold} variant="h6">
                  {Constants.loggedInUser.username}
                </Typography>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center"
            }}
          >
            <Typography>Status</Typography>
            <Box sx={{ width: "100%" }}>
              <Select menuPlacement="auto"
                blurInputOnSelect={false}
                className="basic-single"
                classNamePrefix="select"
                value={status}
                isSearchable={true}
                name="status"
                menuPortalTarget={document.body}
                styles={{
                  ...Constants.Styles,
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
                options={lStatusOption}
                onChange={(selectedOption) => setStatus(selectedOption)}
              />
            </Box>
          </Box>

          <Box display={"flex"} alignItems={"center"} gap="10px" width={"12%"}
            sx={{
              "& .MuiOutlinedInput-input": {
                height: "0.4rem",
              },
              "& .MuiTextField-root": {
                width: "100%",
              }
            }}
          >
            <Typography>From</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="picker"
                ampm={true}
                renderInput={(props) => (
                  <TextField
                    fullWidth
                    {...props}
                    inputProps={{ ...props.inputProps, readOnly: true }}
                  />
                )}
                value={fromDate}
                inputFormat="DD/MM/YYYY"
                onChange={(newValue) => {
                  // Get the current time
                  const now = dayjs();

                  // Set startOfMonth to the first day of the selected month, but with the current system time
                  const fromDate = dayjs(newValue)
                    .hour(now.hour())
                    .minute(now.minute())
                    .second(now.second())
                    .millisecond(now.millisecond())
                    .toDate();

                  setFromDate(fromDate);
                }}
              />
            </LocalizationProvider>
          </Box>

          <Box display={"flex"} alignItems={"center"} gap="10px" width={"11%"}
            sx={{
              "& .MuiOutlinedInput-input": {
                height: "0.4rem",
              },
              "& .MuiTextField-root": {
                width: "100%",
              }
            }}
          >
            <Typography>To</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="picker"
                ampm={true}
                renderInput={(props) => (
                  <TextField
                    fullWidth
                    {...props}
                    inputProps={{ ...props.inputProps, readOnly: true }}
                  />
                )}
                error={false}
                value={toDate}
                inputFormat="DD/MM/YYYY"
                onChange={(newValue) => {
                  // Get the current time
                  const now = dayjs();

                  // Set startOfMonth to the first day of the selected month, but with the current system time
                  const toDate = dayjs(newValue)
                    .hour(now.hour())
                    .minute(now.minute())
                    .second(now.second())
                    .millisecond(now.millisecond())
                    .toDate();

                  setToDate(toDate);
                }}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ "& .MuiFormControlLabel-root": { m: 0 } }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Switch
                      checked={groupBy}
                      onChange={() => setGroupBy(!groupBy)}
                    />
                    <Typography>By Proforma</Typography>
                  </Box>
                }
                label=""
              />
            </FormGroup>
          </Box>

          <Box>
            <LoadingButton
              variant="contained"
              onClick={() => handleSearch(fromDate, toDate, user, userOption)}
              startIcon={<SearchOutlinedIcon size="large" />}
              loading={salesListLoader}
              loadingPosition="start"
              disabled={user.length === 0 && Constants.loggedInUser.usertype !== "C"}
            >
              Search
            </LoadingButton>
          </Box>
        </Box>

        {!groupBy ? (
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "94vw",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                color: "#1976d2",
                padding: "4px 5px",
                borderRadius: "4px",
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: '77vh'
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={false}
              density="compact"
              columns={columns}
              rows={mainData}
              getRowId={(row) => row.id}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "8px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "15px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "22px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: 'bold',
              }}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns id, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
            />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: "black",
                fontWeight: 'normal',
                fontSize: Constants.defaultTableFontSize,
                position: "absolute",
                top: "0.7rem",
                right: "25rem",
                width: "59rem"
              }}
            >
              <p margin={0}>
                <span>Total USD: </span> <b>{totalUSD}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>Total INR: </span> <b>{totalINR}</b>
              </p>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .lavenderCell": {
                color: "#080808",
                backgroundColor: "#D8BFD8",
              },
              height: "77vh",
            }}
          >
            <DataGridPro
              rowHeight={65}
              disableRowSelectionOnClick={false}
              density="compact"
              columns={materialDefaultColumns}
              rows={listData}
              loading={salesListLoader}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                '& .MuiDataGrid-row': {
                  whiteSpace: 'nowrap',
                },
                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.id}
              initialState={{
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              sortModel={[
                {
                  field: 'id',
                  sort: 'desc',
                },
              ]}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              getDetailPanelHeight={getDetailPanelHeight}
              getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
            />
            <Box
              style={{
                position: "absolute",
                top: 2,
                right: "270px",
                display: "flex",
                flexWrap: "nowrap",
              }}
            >
              {salesListLoader ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    onClick={() => handleSearch(fromDate, toDate, user, userOption)}
                    color="primary"
                    fontSize="medium"
                    sx={{ cursor: "pointer", mt: 1 }}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        )}

      </Box>
    </div>
  );
};

export default MixSellProforma;
